import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { getFciBorrowerPayments, getFciOneTimePaymentLink } from 'services'
import { Button, PlainTable } from 'stories/components'
import { setLoanNumber } from 'utils/setLoanNumber'

import { renderFCIvalue } from '../constants'
import { tableBodyData, tableHeaders } from './constants'

export const FciBorrowerPayments = ({ servicerNo = 0 }: { servicerNo?: number }) => {
  const [loading, setLoading] = useState(false)
  const [paymentLinkLoading, setPaymentLinkLoading] = useState(false)
  const [data, setData] = useState<Array<Record<string, any>>>([])

  const initData = async () => {
    setLoading(true)
    const res = await getFciBorrowerPayments(servicerNo)
    setData(res || [])
    setLoading(false)
  }

  useEffect(() => {
    setLoanNumber()
    initData()
  }, [])

  const openOneTimePayment = async () => {
    setPaymentLinkLoading(true)
    try {
      const res = await getFciOneTimePaymentLink(servicerNo)
      const link = res?.link
      if (!link || typeof link !== 'string') {
        toast('FCI one-time payment link is not available for this loan.', { type: 'error' })
        return
      }
      window.open(link, '_blank', 'noopener,noreferrer')
    } catch {
      toast('Failed to get FCI one-time payment link.', { type: 'error' })
    } finally {
      setPaymentLinkLoading(false)
    }
  }

  const tableData = useMemo(() => {
    return data.map((item) => {
      return Object.keys(tableBodyData).map((key: string) => renderFCIvalue(item[key], tableBodyData[key]))
    })
  }, [data])

  return (
    <div className="fci-loan-detail-container px-2">
      <div className="max-w-screen-2xl m-auto">
        <div className="relative bg-white mt-6">
          <LayoutLoading show={loading || paymentLinkLoading} />
          <div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-sm text-gray-600">
              One-time payments are completed on FCI&apos;s secure payment page.
            </p>
            <Button onClick={openOneTimePayment} className="shrink-0">
              Make One-Time Payment
            </Button>
          </div>
          <PlainTable header={tableHeaders} data={tableData} hasPagination />
        </div>
      </div>
    </div>
  )
}
